"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var validations_1 = require("./validations");
var APPLICATION_INSTRUCTIONS = {
    title: "APPLICATION INSTRUCTIONS",
    points: [
        "Fill out the application in its entirety. Make sure to follow all instructions for the two required essays (typed, <strong>no resumes</strong>).\n         Mail or hand deliver the application to the CAVT administrative office:<strong><u>2766 Janitell Road, Colorado Springs, CO, 80906.</u></strong>",
        "Have the personal reference form filled out by <u><i>someone who knows you well and is not related to you.</i></u> This person will need to mail this form <u><i>directly</i></u>\n         to the CAVT administrative office: <strong><u>2766 Janitell Road, Colorado Springs, CO, 80906.</u></strong>",
        "Have <u>official</u> high school transcripts sent <u><i>directly</i></u> from your high school's records office to the CAVT administrative office:\n         <strong><u>2766 Janitell Road, Colorado Springs, CO, 80906.</u></strong>",
        "Any <u>official</u> college transcripts must be sent <u><i>directly</i></u> from your college's records office to the CAVT administrative office:\n         <strong><u>2766 Janitell Road, Colorado Springs, CO, 80906.</u></strong>\n         "
    ],
    footer: {
        right: {
            title: "Colorado Academy of Veterinary Technology",
            address: "2766 Janitell Road, Colorado Springs, CO 80906 ",
            office: "(719) 219-9636",
            fax: "(719) 302-5577",
            email: "cbaker@cavt.edu"
        },
        startPage: "1",
        endPage: "5"
    }
};
exports.APPLICATION_INSTRUCTIONS = APPLICATION_INSTRUCTIONS;
var ENROLLMENT_INFORMATION = {
    title: "ENROLLMENT INFORMATION",
    title2: "EDUCATION INFORMATION",
    title3: "PLEASE PROVIDE THE FOLLOWING",
    rules: {
        last_name: __assign(__assign({}, validations_1.mandatory), { format: {
                pattern: "[a-zA-Z-.' ]+",
                flags: "i",
                message: "can only contain characters, spaces, up quotes and dots",
                length: {
                    minimum: 1,
                    maximum: 30
                }
            } }),
        first_name: __assign(__assign({}, validations_1.mandatory), { format: {
                pattern: "[a-zA-Z-.' ]+",
                flags: "i",
                message: "can only contain characters, spaces, up quotes and dots",
                length: {
                    minimum: 1,
                    maximum: 20
                }
            } }),
        address: validations_1.mandatory,
        city: validations_1.mandatory,
        state: validations_1.mandatory,
        zip: validations_1.mandatory,
        cell_phone: validations_1.mandatory,
        email: validations_1.email,
        social: validations_1.mandatory,
        date_of_birth: validations_1.mandatory,
        state_of_resdency: validations_1.mandatory,
        high_school: validations_1.mandatory,
        high_school_date: validations_1.mandatory,
        quarter: validations_1.mandatory
    },
    default: {
        first_name: {
            key: "first_name",
            value: ""
        },
        last_name: {
            key: "last_name",
            value: ""
        },
        felony: {
            key: "felony",
            value: "no"
        },
        cell_phone: {
            key: "cell_phone",
            value: ""
        }
    },
    requirements: [
        "<strong><u>Official high school transcript.</u></strong> This must be mailed from the high school records office directly to the\n        Colorado Academy of Veterinary Technology (CAVT).",
        "<strong><u>College Transcript (if any).</u></strong> These must be mailed from the college records to Colorado Academy of Veterinary Technology (CAVT).",
        "<strong><u>The enclosed personal letter of reference.</u></strong> This must be someone who knows you well and is not related to you.\n        This must be mailed directly from the referring individual to Colorado Academy of Veterinary Technology (CAVT)."
    ],
    footer: {
        right: {
            title: "Colorado Academy of Veterinary Technology",
            address: "2766 Janitell Road, Colorado Springs, CO 80906 ",
            office: "(719) 219-9636",
            fax: "(719) 302-5577",
            email: "cbaker@cavt.edu"
        },
        startPage: "2",
        endPage: "5"
    }
};
exports.ENROLLMENT_INFORMATION = ENROLLMENT_INFORMATION;
var DISCLAIMER_SIGNATURE = {
    title: "REQUIRED WRITING SAMPLES",
    subtitle: "Instructions",
    instructions: [
        "Please type responses to both essay questions on separate sheets of paper.",
        "Do not write essays on any part of this application.",
        "Do not submit a resume in response to essay 2.",
        "Essay should be typed and approximately one to two pages (longer is acceptable)."
    ],
    instructionsSteps: [
        "Personal Essay: Please tell the admissions committee why you want to become a veterinary technician.",
        "Please describe the one or two of the most important jobs you have held (if any), This does not have to be animal-related"
    ],
    title2: "Disclaimer and Signature",
    rules: {
        signature: { presence: { allowEmpty: false, message: "^Signature is required" } },
        disclaimer_name: validations_1.mandatory,
        student_signature_1_date: {
            presence: { allowEmpty: false, message: "^Signature date is required" }
        }
    },
    emailSenders: [
        { label: "Admissions:", name: "Carolyn Baker", email: "cbaker@cavt.edu" },
        { label: "Financial Aid:", name: "Traci Thompson", email: "tthompson@cavt.edu" },
        { label: "Executive Assistant to CEO:", name: "Jolene Whatley", email: "jwhatley@cavt.edu" }
    ],
    footer: {
        right: {
            title: "Colorado Academy of Veterinary Technology",
            address: "2766 Janitell Road, Colorado Springs, CO 80906 ",
            office: "(719) 219-9636",
            fax: "(719) 302-5577",
            email: "cbaker@cavt.edu",
            web: "www.cavt.edu"
        },
        startPage: "3",
        endPage: "5"
    }
};
exports.DISCLAIMER_SIGNATURE = DISCLAIMER_SIGNATURE;
var PERSONAL_REFERENCE = {
    title: "PERSONAL REFERENCE FORM",
    rates: [
        "Motivation",
        "Integrity",
        "Emotional maturity",
        "Ability to work with others",
        "Desire to help others including animals and people"
    ],
    rules: {
        reference_name: validations_1.mandatory,
        reference_signature: validations_1.mandatory,
        reference_date: validations_1.mandatory,
        reference_address: validations_1.mandatory,
        reference_email: validations_1.mandatory,
        reference_phone: validations_1.mandatory,
        reference_job_title: validations_1.mandatory
    },
    footer: {
        right: {
            title: "Colorado Academy of Veterinary Technology",
            address: "2766 Janitell Road, Colorado Springs, CO 80906 ",
            office: "(719) 219-9636",
            fax: "(719) 302-5577",
            email: "cbaker@cavt.edu",
            web: "www.cavt.edu"
        },
        startPage: "4",
        endPage: "5"
    }
};
exports.PERSONAL_REFERENCE = PERSONAL_REFERENCE;
var DISCLAIMER_PARENT_SIGNATURE = {
    rules: {
        parent_signature_1: {
            presence: { allowEmpty: false, message: "^Parent signature is required" }
        }
    },
    default: {
        key: "parent_signature_1"
    }
};
exports.DISCLAIMER_PARENT_SIGNATURE = DISCLAIMER_PARENT_SIGNATURE;
var FINANCIAL_AID = {
    title: "How to Create an FSA ID",
    steps: [
        "The FSA ID - a username and password - has replaced the Federal Student Aid PIN and must be used to log in the certain U.S. Department\n        of Education websites. Your FSA ID confirms your identity when you access your financial aid information and electronically sign Federal\n        Student Aid documents. If you do not already have an FSA ID, you can create one when loggin into <a href=\"https://studentaid.gov/h/apply-for-aid/fafsa\" target=\"_blank\">fafsa.gov</a>,\n        the National Student Loan Data System (NSLDS) at  <a href=\"https://nslds.ed.gov/\" target=\"_blank\">nslds.ed.gov</a>,\n        <a href=\"https://studentaid.gov/app/launchTeach.action\" target=\"_blank\">Loans.gov</a>, <a href=\"https://studentaid.gov/\" target=\"_blank\">StudentAig.gov</a>,\n        and Agreement to Serve (ATS) at <a href=\"https://studentaid.gov/\" target=\"_blank\">www.teach-ats.ed.gov</a>.",
        "When logging into one of the websites listed above, click the link to create an FSA ID.",
        "Create a username and password, and enter you e-mail address.",
        "Enter your name, date of birth, Social Security Number, contact information, and challenge questions and answers.",
        "If you have a federal Student Aid PIN, you will be able to enter it and link it to your FSA ID.\n        You can still create a FSA ID if you have forgotten or do not have a PIN.",
        "Review your information, and read and accept the terms and conditions.",
        "Confirm your e-mail address using the secure code, which will be sent to the email address you entered when you created your FSA ID.\n        Once you verify your email address, you can use it instead of your username to log into websites.",
        "You can use your FSA ID to sign a FAFSA right away. Once the Social Security Administration verifies your information in one to three days,\n        or if you have linked your PIN to your FSA ID, you will be able to use your FSA ID to access the websites listed above.",
        "For help, visit, <a href=\"https://studentaid.gov/fsa-id/sign-in/\" target=\"_blank\">StudentAid.gov/fsaid</a>"
    ],
    footer: {
        right: {
            title: "Colorado Academy of Veterinary Technology",
            address: "2766 Janitell Road, Colorado Springs, CO 80906 ",
            office: "(719) 219-9636",
            fax: "(719) 302-5577",
            email: "cbaker@cavt.edu",
            web: "www.cavt.edu",
            code: "041850"
        },
        startPage: "5",
        endPage: "5"
    }
};
exports.FINANCIAL_AID = FINANCIAL_AID;
//# sourceMappingURL=data:application/json;base64,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